import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API, CidLog, LogViewType, ProductType, PRODUCT_TYPES } from '@apps/api-interfaces';
import { getCookie } from '@apps/tools';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class AgentService {
  constructor(private http: HttpClient, private router: Router) {}

  async log(
    view: LogViewType,
    data: CidLog = this.getCurrentLogDetails(),
    cid: string = getCookie('cid')
  ): Promise<any> {
    if (!cid || !view) {
      return false;
    }
    const url = `${API.LOGS}/${cid}/${view}`;
    return await this.http
      .post(url, data)
      .pipe(catchError(() => of(false)))
      .toPromise();
  }

  async getPixel(cid: string = getCookie('cid')): Promise<string> {
    if (!cid) {
      return undefined;
    }
    const url = `${API.USER_SETTINGS}/cid/${cid}`;
    return await this.http
      .get<{ trackingPixel: string }>(url)
      .pipe(map(e => e && e.trackingPixel))
      .toPromise();
  }

  private getCurrentLogDetails(): CidLog {
    const data: CidLog = {};
    if (document.referrer && document.referrer.indexOf('https://zatrzymajlicznik.pl') !== 0 && document.referrer.indexOf('http://localhost') !== 0 ) {
      data.referral = document.referrer;
    }

    const path = this.router.url.split('/');
    if (PRODUCT_TYPES.map(e => e.id).includes(path[1])) {
      data.product = path[1] as ProductType;
    }

    return data;
  }
}
